import React from 'react';

// https://app.zeplin.io/styleguide/6034e4f5b32a939088992768/components?coid=60a783cc0e84952b32e55cbd
export default function CrossIcon(props) {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g fill='currentColor'>
        <path d='M9.707 8.293l6.364 6.363 6.364-6.363c.39-.39 1.024-.39 1.414 0 .39.39.39 1.024 0 1.414l-6.364 6.364 6.364 6.364c.39.39.39 1.024 0 1.414-.39.39-1.023.39-1.414 0l-6.364-6.364-6.364 6.364c-.39.39-1.024.39-1.414 0-.39-.39-.39-1.023 0-1.414l6.363-6.364-6.363-6.364c-.39-.39-.39-1.024 0-1.414.39-.39 1.024-.39 1.414 0z' />
      </g>
    </svg>
  );
}
